import React, { useState } from "react";
import { X } from "lucide-react";

export default function ChipInput({ values = [], onChange, placeholder, testId }) {
  const [text, setText] = useState("");

  const add = (val) => {
    const v = val.trim();
    if (!v) return;
    if (values.includes(v)) return;
    onChange([...values, v]);
    setText("");
  };

  const remove = (v) => onChange(values.filter((x) => x !== v));

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      add(text);
    } else if (e.key === "Backspace" && !text && values.length) {
      onChange(values.slice(0, -1));
    }
  };

  return (
    <div
      className="flex flex-wrap items-center gap-1 min-h-9 bg-white border border-zinc-200 focus-within:border-zinc-950 focus-within:ring-1 focus-within:ring-zinc-950 rounded-md shadow-sm px-2 py-1 text-sm"
      data-testid={testId}
    >
      {values.map((v) => (
        <span
          key={v}
          className="inline-flex items-center gap-1 rounded-full bg-zinc-100 border border-zinc-200 px-2 py-0.5 text-xs font-medium"
        >
          {v}
          <button
            type="button"
            onClick={() => remove(v)}
            className="text-zinc-400 hover:text-red-600"
            data-testid={`${testId}-remove-${v}`}
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      <input
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={() => add(text)}
        placeholder={values.length ? "" : placeholder}
        className="flex-1 min-w-[60px] bg-transparent outline-none text-sm h-7"
      />
    </div>
  );
}
